import { Link } from 'react-router-dom';
import {
  ClipboardList,
  Layers,
  Package,
  Scale,
  ShoppingCart,
} from 'lucide-react';

/**
 * Índice de reportes de inventario (PROMPT_N°054).
 *
 * Reemplaza la pantalla mock que había acá (619 líneas de datos
 * inventados, oculta del menú con un badge "Pendiente"). Mostrar números
 * falsos es peor que no mostrar nada: el cliente no tiene forma de saber
 * que no eran reales.
 */

const REPORTES = [
  {
    ruta: '/reportes/existencias',
    titulo: 'Existencias valorizadas',
    descripcion:
      'Qué hay en bodega hoy, en qué estado y cuánto vale. Totales por categoría.',
    icono: Package,
    tono: 'bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300',
  },
  {
    ruta: '/reportes/conciliacion',
    titulo: 'Conciliación del período',
    descripcion:
      'Saldo inicial, entradas, salidas y saldo final por ingrediente, contra lo que dice el sistema.',
    icono: Scale,
    tono: 'bg-violet-50 text-violet-700 dark:bg-violet-900/30 dark:text-violet-300',
  },
  {
    ruta: '/reportes/lotes',
    titulo: 'Lotes y vencimientos',
    descripcion:
      'Lotes con disponible, semáforo de vencimiento y cuánta plata vence en 7 y 30 días.',
    icono: Layers,
    tono: 'bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300',
  },
  {
    ruta: '/reportes/compras',
    titulo: 'Compras del período',
    descripcion:
      'Facturas por proveedor y su detalle. Las recepciones sin factura van aparte.',
    icono: ShoppingCart,
    tono: 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300',
  },
  {
    ruta: '/reportes/conteo',
    titulo: 'Planilla de conteo físico',
    descripcion:
      'Para imprimir y contar a mano. Sin el stock del sistema, salvo que se pida.',
    icono: ClipboardList,
    tono: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300',
  },
];

export default function Reportes() {
  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
          Reportes de inventario
        </h1>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Todos se pueden exportar a Excel o imprimir. Ninguno modifica datos.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {REPORTES.map((r) => {
          const Icono = r.icono;
          return (
            <Link
              key={r.ruta}
              to={r.ruta}
              className="group bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-5 hover:border-blue-400 dark:hover:border-blue-600 hover:shadow-sm transition"
            >
              <div
                className={`inline-flex items-center justify-center h-10 w-10 rounded-lg ${r.tono} mb-3`}
              >
                <Icono className="h-5 w-5" />
              </div>
              <h2 className="text-base font-semibold text-gray-900 dark:text-gray-100 group-hover:text-blue-700 dark:group-hover:text-blue-300">
                {r.titulo}
              </h2>
              <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                {r.descripcion}
              </p>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
